import { ButtonStyle, ControlSize } from "../base/types";
import { FC, HTMLAttributes } from "react";

import { MUIIcon } from "./MUIIcon";
import { Spinner } from "./Spinner";
import clsx from "clsx";

export interface IButtonAttributes extends HTMLAttributes<HTMLButtonElement> {
    icon?: string
    label?: string
    iconClassName?: string
    buttonStyle?: ButtonStyle
    buttonSize?: ControlSize
    disabled?: boolean
    isLoading?: boolean
}

export const Button: FC<IButtonAttributes> = ({
    label, className, icon, iconClassName, isLoading, buttonStyle, buttonSize, children, ...props
}) => {
    const buttonClassName = clsx(
        className,
        ButtonClassTemplate.className({ style: buttonStyle, size: buttonSize, defaultClass: "btn-secondary" }))
    return <>
        <button {...props} className={buttonClassName}>
            {(icon) && <>
                {(isLoading) ?
                    <Spinner show={true} /> :
                    <MUIIcon iconName={icon} className={iconClassName} />}
            </>}
            {label}
            {children}
        </button>
    </>
}

class ButtonClassTemplate {
    private static styleClass(style?: ButtonStyle, defaultClass?: string) {
        switch (style) {
            case ButtonStyle.Primary: return "btn-primary";
            case ButtonStyle.Secondary: return "btn-secondary";
            case ButtonStyle.Success: return "btn-success";
            case ButtonStyle.Danger: return "btn-danger";
            case ButtonStyle.Warning: return "btn-warning";
            case ButtonStyle.Info: return "btn-info";
            case ButtonStyle.Light: return "btn-light";
            case ButtonStyle.Dark: return "btn-dark";
            case ButtonStyle.Link: return "btn-link";
            case ButtonStyle.OutlinePrimary: return "btn-outline-primary";
            case ButtonStyle.OutlineSecondary: return "btn-outline-secondary";
            case ButtonStyle.OutlineSuccess: return "btn-outline-success";
            case ButtonStyle.OutlineDanger: return "btn-outline-danger";
            case ButtonStyle.OutlineWarning: return "btn-outline-warning";
            case ButtonStyle.OutlineInfo: return "btn-outline-info";
            case ButtonStyle.OutlineLight: return "btn-outline-light";
            case ButtonStyle.OutlineDark: return "btn-outline-dark";
            default: return defaultClass;
        }
    }

    private static buttonSizeClass(size?: ControlSize) {
        switch (size) {
            case ControlSize.Default: return "";
            case ControlSize.Large: return "btn-lg";
            case ControlSize.Medium: return "btn-md";
            case ControlSize.Small: return "btn-sm";
        }
    }

    public static className({ style, size, defaultClass }: { style?: ButtonStyle, size?: ControlSize, defaultClass?: string }) {
        const buttonStyle = this.styleClass(style, defaultClass)
        const buttonSize = this.buttonSizeClass(size)
        return clsx("btn", buttonStyle, buttonSize)
    }
}